export default __webpack_public_path__ + "static/soehne-web-leicht-kursiv-6af95314ec396f8db5ce9a8873cf47ee.woff2";